// Winner
export const RESET_VALUES = 'RESET_VALUES';

export const GET_WINNER_SUCCESS = 'GET_WINNER_SUCCESS';
export const GET_WINNER_ERROR = 'GET_WINNER_ERROR';



// WEBPACK FOOTER //
// ./src/actions/winner-actions.js